import axios from "axios";
import config from "./index.js"
const BASE_URL = config.BASE_URL;

const TOKEN = sessionStorage.getItem("token");
const apiClient = axios.create({
    baseURL: `${BASE_URL}/portal`,
    headers: {
        // "Content-Type": "application/json",
        "Authorization": `Bearer ${TOKEN}`
    }
})
export default apiClient;